import React, { useEffect, useState } from "react";
import DashboardTableComponent from "./DashboardTableComponent";

import { Select } from "antd";
import { useTheme } from "../../utils/ThemeContext";
import DASHBOARD_API from "../../apis/dashboard.api";
import DEATH_API from "../../apis/death.api";

import NewLoader from "../styled-components/loader/NewLoader";
import { MODULE_API } from "../../apis";

const StoredDocumentsTable = () => {
  const { theme } = useTheme();

  const [documentsFilter, setDocumentsFilter] = useState("Death");
  const [storedDocumentList, setStoredDocumentList] = useState([]);
  const [loading, setLoading] = useState(false);

  const extractFileNameFromUrl = (url) => {
    const urlParts = url.split("/");
    return urlParts[urlParts.length - 1]; // Get the last part of the URL, which is the file name
  };
  
  const getStoredDocuments = async () => {
    try {
      setLoading(true);
      const response = await DASHBOARD_API.fetchStoredDocuments();
      if (response && response.data) {
        const filteredData = response.data.filter(
          (item) => item.fileUrl !== null
        );
        setStoredDocumentList(filteredData);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("error while getting stored documents==>", error);
    }
  };
  const getStoredDocumentsCollectable = async (docsType) => {
    try {
      setLoading(true);
      const response = await MODULE_API.fetchModulesDocs(docsType);
      if (response && response.data && response.data.rows) {
        const filteredData = response.data.rows.filter(
          (item) => item.fileUrl !== null
        );
        let allDocsData = response.data.rows.map((item) => {
          return {
            id: item.id,
            cmId:item.cmId,
            fileUrl: item.fileUrl && item.fileUrl,
            type:docsType,
            tag:item.tag && item.tag,
            fileName:
              item.fileName ||
              (item.fileUrl && extractFileNameFromUrl(item.fileUrl)),
          };
        });
        setStoredDocumentList((prevState) => [...prevState, ...allDocsData]);
        // setStoredDocumentList(allDocsData);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("error while getting stored documents==>", error);
    }
  };
  const getStoredDocumentsAssets = async (docsType) => {
    try {
      setLoading(true);
      const response = await MODULE_API.fetchModulesDocs(docsType);
      if (response && response.data && response.data.rows) {
        const filteredData = response.data.rows.filter(
          (item) => item.fileUrl !== null
        );
        let allDocsData = response.data.rows.map((item) => {
          return {
            id: item.id,
            cmId:item.cmId,
            fileUrl: item.fileUrl && item.fileUrl,
            type:docsType,
            tag:item.tag && item.tag,
            fileName:
              item.fileName ||
              (item.fileUrl && extractFileNameFromUrl(item.fileUrl)),
          };
        });
        setStoredDocumentList((prevState) => [...prevState, ...allDocsData]);
        // setStoredDocumentList(allDocsData);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("error while getting stored documents==>", error);
    }
  };
  const getStoredDocumentsDeath = async (docsType) => {
    try {
      setLoading(true);
      const response = await MODULE_API.fetchModulesDocs(docsType);
      if (response && response.data && response.data.rows) {
        const filteredData = response.data.rows.filter(
          (item) => item.fileUrl !== null
        );
        let allDocsData = response.data.rows.map((item) => {
          return {
            id: item.id,
            cmId:item.cmId,
            fileUrl: item.fileUrl && item.fileUrl,
            type:docsType,
            tag:item.tag && item.tag,
            fileName:
              item.fileName ||
              (item.fileUrl && extractFileNameFromUrl(item.fileUrl)),
          };
        });
        setStoredDocumentList((prevState) => [...prevState, ...allDocsData]);
        // setStoredDocumentList(allDocsData);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("error while getting stored documents==>", error);
    }
  };
  const getStoredDocumentsInsurance = async (docsType) => {
    try {
      setLoading(true);
      const response = await MODULE_API.fetchModulesDocs(docsType);
      if (response && response.data && response.data.rows) {
        const filteredData = response.data.rows.filter(
          (item) => item.fileUrl !== null
        );
        let allDocsData = response.data.rows.map((item) => {
          return {
            id: item.id,
            cmId:item.cmId,
            fileUrl: item.fileUrl && item.fileUrl,
            type:docsType,
            tag:item.tag && item.tag,
            fileName:
              item.fileName ||
              (item.fileUrl && extractFileNameFromUrl(item.fileUrl)),
          };
        });
        setStoredDocumentList((prevState) => [...prevState, ...allDocsData]);
        // setStoredDocumentList(allDocsData);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("error while getting stored documents==>", error);
    }
  };
  const getAllDocuments = async (docsType) => {
    // await getStoredDocuments();
    setStoredDocumentList([]);
    await getStoredDocumentsDeath("death");
    await getStoredDocumentsCollectable("collection");
    await getStoredDocumentsAssets("assets");
    await getStoredDocumentsInsurance("insurance");

  };
  useEffect(() => {
    const docsType = "death";
    getAllDocuments(docsType);
  }, []);

  const handleDeleteDocument = async (id) => {
    try {
      setLoading(true);
      await MODULE_API.deleteModulesDocs(id);
      await getAllDocuments();
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("error while try to delete the document", error);
    }
  };
  const documentsFilterData = [
    {
      id: 1,
      filter: "Collectibles",
      docsType: "collection",
    },
    {
      id: 2,
      filter: "Death",
      docsType: "death",
    },
  ];

  const headers = ["Document", "Module", "Action"];

  return (
    <div
      style={{
        position: "relative",
        width: "100%",
        backgroundColor: theme === "dark" ? "#232323" : "white",
        padding: "1rem",
        borderRadius: "16px",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
          backgroundColor: theme === "dark" ? "#232323" : "white",
        }}
      >
        <div>
          <h3
            style={{
              color: theme === "light" ? "#232323" : "white",
            }}
          >
            Stored Documents
          </h3>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
          {/* <p style={{ margin: "0" }}>Module</p>
          <Select
            labelInValue
            defaultValue={{ value: "Select", label: "Select" }}
            style={{ width: 120 }}
            onChange={() => {}}
            options={[
              { value: "July", label: "July" },
              { value: "August", label: "August" },
              { value: "October", label: "October" },
            ]}
          /> */}
         {/* <div className="compareSelect">
            {documentsFilterData &&
              documentsFilterData.map((item, index) => (
                <div
                  key={index}
                  className={
                    item.filter === documentsFilter
                      ? "selectedfilter"
                      : "unSelectedfilter"
                  }
                  onClick={() => {
                    setDocumentsFilter(item.filter);
                    setStoredDocumentList([]);
                    getStoredDocumentsCollectable(item.docsType);
                  }}
                >
                  {item.filter}
                </div>
              ))}
          </div> */}
        </div>
      </div>

      <DashboardTableComponent
        theme={theme}
        headers={headers}
        data={storedDocumentList}
        handleDeleteDocument={handleDeleteDocument}
        getStoredDocuments={getAllDocuments}
        filter={documentsFilter}
      />
      <NewLoader isLoading={loading} />
    </div>
  );
};

export default StoredDocumentsTable;
